import React from 'react';
import TextInput from 'components/form/text/text';
import track from '../../lib/drip';
import AuthButtons from './auth_buttons';
import { getCSRFToken } from 'lib/request_deprecated';
import Button from 'lj_shared/button/button';

const styles = require('./login.module.scss');
const logo = require('images/lj_logo.png');

export interface LoginProps {
  urls: {
    password: string;
    login: string;
    socialUrls: {
      linkedin: string;
      facebook: string;
      github: string;
      google: string;
      microsoft: string;
    };
  };
  language: {
    title: string;
    mail: string;
    password: string;
    forgot: string;
    login_btn: string;
    yet: string;
  };
}

const LoginContainer: React.FunctionComponent<LoginProps> = props => {
  const { title, mail, password, forgot, login_btn, yet } = props.language;

  const handleForgotClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    track('action', {
      name: 'work-login-click',
      controller: 'work',
      action: 'havent-signed-up-yet',
    });
  };

  const handleForgotKeyDown = (e: React.KeyboardEvent<HTMLAnchorElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleForgotClick(e as any);
    }
  };

  const handleSignupClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    track('action', {
      name: 'work-login-click',
      controller: 'work',
      action: 'havent-signed-up-yet',
    });
  };

  const handleSignupKeyDown = (e: React.KeyboardEvent<HTMLAnchorElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleSignupClick(e as any);
    }
  };

  return (
    <main className={styles.container} role='main' aria-label='Login'>
      <img className={styles.logo} src={logo} alt='Landing.Jobs' />
      <h1 className={styles.title}>{title}</h1>
      <form className={styles.form} action={props.urls.login} method='post' aria-label='Login form'>
        <input name='authenticity_token' value={getCSRFToken()} type='hidden' />
        <TextInput
          label='Email'
          name='user[email]'
          placeholder={mail}
          color='tuftsBlue'
          type='email'
          required={true}
        />
        <TextInput
          label='Password'
          name='user[password]'
          placeholder={password}
          color='tuftsBlue'
          type='password'
          required={true}
        />
        <a
          onClick={handleForgotClick}
          onKeyDown={handleForgotKeyDown}
          className={styles.forgot}
          href={props.urls.password}
          aria-label='Forgot password link'
        >
          {forgot}
        </a>
        <Button
          onClick={() =>
            track('action', {
              name: 'work-login-click',
              controller: 'work',
              action: 'login',
            })
          }
          buttonColor='puertoRico'
          otherClasses={styles.button}
          buttonSize='mid'
          isButton={true}
          aria-label='Login button'
        >
          {login_btn}
        </Button>
      </form>
      <a
        onClick={handleSignupClick}
        onKeyDown={handleSignupKeyDown}
        className={styles.signup}
        href='/join'
        aria-label='Sign up link'
      >
        {yet}
      </a>
      <AuthButtons kind='Log in' urls={props.urls.socialUrls} />
      <div className={styles.authNote}>Social login only available for Job Seekers, for now.</div>
    </main>
  );
};

export default LoginContainer;
